import React from "react";
import { Table } from "antd";
const CombinedSocialSecurityTable = ({ tableData, cols }) => {
  return (
    <div className="social-security-breakdown">
      <Table
        bordered
        pagination={false}
        columns={cols}
        dataSource={tableData || []}
        rowKey={(record, index) => index}
        className="combined-antd3-table"
      />
    </div>
  );
};

export default CombinedSocialSecurityTable;
